import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from '../../../helpers/modal.tokens';
import { ChallengesService } from '../../../services/challenges.service';
import { DataManipulationService } from '../../../services/data-manipulation.service';

@Component({
  selector: 'app-own-action-modal',
  templateUrl: './own-action-modal.component.html',
  styleUrls: ['./own-action-modal.component.scss']
})
export class OwnActionModalComponent {
  selectedTeamLeader: any;

  constructor(@Inject(MODAL_DATA) public config: { statement: any },
              private dialogRef: MatDialogRef<any>,
              public challengesService: ChallengesService,
              public data: DataManipulationService) { }

  close(result?: { member: any }) {
    this.dialogRef.close(result);
  }
}
